<template>
  <!-- 添加或编辑对话框 -->
  <el-dialog class="xiaobu-form-dialog" :title="baseForm.skuAttrId ? (isEdit ? '编辑规格属性' : '查看规格属性') : '新增规格属性'"
    v-bind="$attrs" v-on="$listeners">
    <div class="edit-box flex-c-e" v-show="baseForm.skuAttrId">
      <el-button v-if="mixinHasPermi(['product:skuAttr:update'])" type="primary" class="edit" @click="toggleEdit">{{
        isEdit ? "取消编辑" : "编辑"
      }}</el-button>
    </div>
    <div class="el-dialog-body-child">
      <el-form class="clearfix" ref="dialogFormRef" :model="dialogForm" :rules="rules"
        :disabled="!!(!isEdit && baseForm.skuAttrId)" label-width="120px">
        <el-form-item class="all" label="规格属性名称" prop="skuAttrName">
          <el-input v-model.trim="dialogForm.skuAttrName" clearable placeholder="请输入规格属性名称" />
        </el-form-item>
        <el-form-item class="all" label="备注" prop="remark">
          <el-input type="textarea" v-model="dialogForm.remark" :autosize="{ minRows: 5, maxRows: 8 }" clearable
            placeholder="请输入备注" />
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <template>
        <el-button @click="$emit('close')">{{
          !baseForm.skuAttrId || isEdit ? "取 消" : "关 闭"
        }}</el-button>
        <el-button type="primary" @click="submitForm" v-show="!baseForm.skuAttrId || isEdit">确 定</el-button>
      </template>
    </div>
  </el-dialog>
</template>
<script>
import { skuAttrApi } from "@/api"
export default {
  name: "SkuAttrDialog",
  props: {
    // 是否是编辑
    isUpdate: {
      type: Boolean,
      default: false
    },
    // 配置数据
    baseForm: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    /** 检查是否已存在 */
    const checkSkuAttrName = (rule, value, callback) => {
      skuAttrApi
        .judgeExist({ skuAttrName: value, skuAttrId: this.baseForm.skuAttrId })
        .then((data) => {
          if (data.validateResult) {
            callback()
          } else {
            callback(data.msg)
          }
        })
    }
    return {
      isEdit: false, // 是否是在编辑
      dialogForm: {}, // 弹框表单
      // 表单校验
      rules: {
        skuAttrName: [
          { required: true, message: "请输入规格属性名称", trigger: "blur" },
          { validator: checkSkuAttrName, trigger: "blur" }
        ]
      }
    }
  },
  watch: {
    isUpdate(val) {
      this.isEdit = val
    },
    // 监听baseForm变化 拷贝baseForm
    baseForm: {
      handler: function(val) {
        this.dialogForm = JSON.parse(JSON.stringify(val))
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    // 编辑或取消编辑
    toggleEdit() {
      if (!this.isEdit) {
        this.isEdit = true
        return
      }
      this.isEdit = false
      this.dialogForm = JSON.parse(JSON.stringify(this.baseForm))
    },
    // 重置表单
    resetForm() {
      this.isEdit = false
      this.$nextTick(() => {
        this.$refs.dialogFormRef.clearValidate()
      })
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["dialogFormRef"].validate((valid) => {
        if (valid) {
          //更新
          if (this.dialogForm.skuAttrId) {
            skuAttrApi.updateItem(this.dialogForm).then((data) => {
              this.$modal.msgSuccess("编辑规格属性成功")
              this.$emit("close")
              this.$emit("successs")
            })
          } else {
            //新增
            skuAttrApi.createItem(this.dialogForm).then((data) => {
              this.$modal.msgSuccess("新增规格属性成功")
              this.$emit("close")
              this.$emit("successs")
            })
          }
        }
      })
    }
  }
}
</script>
